var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_1044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5641 56.0627C31.2619 56.0627 30.9575 55.9588 30.7092 55.7473L22.1626 48.4699C21.8678 48.2185 21.6982 47.8515 21.6982 47.4638C21.6982 47.0769 21.8685 46.7098 22.1626 46.4585L30.7092 39.1811C31.2641 38.7079 32.0977 38.775 32.5709 39.33C33.0433 39.8857 32.977 40.7193 32.4213 41.1917L25.0561 47.4638L32.4213 53.7359C32.977 54.2091 33.0433 55.0427 32.5709 55.5977C32.3092 55.905 31.9378 56.0627 31.5641 56.0627Z",
    fill: "url(#paint0_linear_103_1044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4362 56.0627C48.0625 56.0627 47.691 55.905 47.4301 55.5977C46.9569 55.0427 47.024 54.2091 47.579 53.7359L54.9441 47.4638L47.579 41.1917C47.024 40.7193 46.9569 39.8857 47.4301 39.33C47.9025 38.775 48.7369 38.7079 49.2911 39.1811L57.8377 46.4585C58.1325 46.7098 58.302 47.0769 58.302 47.4638C58.302 47.8515 58.1325 48.2185 57.8377 48.4699L49.2911 55.7473C49.0427 55.9588 48.7383 56.0627 48.4362 56.0627Z",
    fill: "url(#paint1_linear_103_1044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9747 61.5211C36.884 61.5211 36.7927 61.5116 36.7005 61.4924C35.9871 61.342 35.5301 60.6411 35.6805 59.9277L41.007 34.638C41.1573 33.9246 41.8575 33.4676 42.5717 33.618C43.2851 33.7683 43.7421 34.4685 43.5917 35.1827L38.2652 60.4723C38.134 61.0944 37.5857 61.5211 36.9747 61.5211Z",
    fill: "url(#paint2_linear_103_1044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1321 75.2993H8.86793C3.97848 75.2993 0 71.3216 0 66.4314V13.585C0 8.69552 3.97848 4.71704 8.86793 4.71704H71.1321C76.0215 4.71704 80 8.69552 80 13.585V66.4314C80 71.3216 76.0215 75.2993 71.1321 75.2993ZM8.86793 7.35855C5.43485 7.35855 2.64151 10.1519 2.64151 13.585V66.4314C2.64151 69.8644 5.43485 72.6578 8.86793 72.6578H71.1321C74.5652 72.6578 77.3585 69.8644 77.3585 66.4314V13.585C77.3585 10.1519 74.5652 7.35855 71.1321 7.35855H8.86793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6793 25.8661H1.32075C0.591097 25.8661 0 25.275 0 24.5454C0 23.8164 0.591097 23.2246 1.32075 23.2246H78.6793C79.4089 23.2246 80 23.8164 80 24.5454C80 25.275 79.4089 25.8661 78.6793 25.8661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5664 19.5459C20.2625 19.5459 18.3867 17.6702 18.3867 15.3662C18.3867 13.0615 20.2625 11.1865 22.5664 11.1865C24.8711 11.1865 26.7461 13.0615 26.7461 15.3662C26.7461 17.6702 24.8711 19.5459 22.5664 19.5459ZM22.5664 13.828C21.7188 13.828 21.0282 14.5179 21.0282 15.3662C21.0282 16.2145 21.7188 16.9044 22.5664 16.9044C23.4147 16.9044 24.1046 16.2145 24.1046 15.3662C24.1046 14.5179 23.4147 13.828 22.5664 13.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72412 19.5054C7.41943 19.5054 5.54443 17.6304 5.54443 15.3257C5.54443 13.021 7.41943 11.146 9.72412 11.146C12.0288 11.146 13.9038 13.021 13.9038 15.3257C13.9038 17.6304 12.0288 19.5054 9.72412 19.5054ZM9.72412 13.7875C8.87654 13.7875 8.18594 14.4781 8.18594 15.3257C8.18594 16.174 8.87654 16.8639 9.72412 16.8639C10.5724 16.8639 11.2623 16.174 11.2623 15.3257C11.2623 14.4781 10.5724 13.7875 9.72412 13.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4084 19.5857C33.1045 19.5857 31.2295 17.7107 31.2295 15.406C31.2295 13.1021 33.1045 11.2271 35.4084 11.2271C37.7131 11.2271 39.5881 13.1021 39.5881 15.406C39.5881 17.7107 37.7131 19.5857 35.4084 19.5857ZM35.4084 13.8678C34.5609 13.8678 33.871 14.5577 33.871 15.406C33.871 16.2543 34.5609 16.9442 35.4084 16.9442C36.2568 16.9442 36.9466 16.2543 36.9466 15.406C36.9466 14.5577 36.2568 13.8678 35.4084 13.8678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_1044",
    x1: 32.8859,
    y1: 47.4642,
    x2: 21.6982,
    y2: 47.4642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F69C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_1044",
    x1: 58.302,
    y1: 47.4642,
    x2: 47.1147,
    y2: 47.4642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F69C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_1044",
    x1: 43.6204,
    y1: 47.5552,
    x2: 35.6519,
    y2: 47.5552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F69C1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_1044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.263dab63111dc108bb36a9dba8627e2d.svg";
export { ForwardRef as ReactComponent };